import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../helpers/Axios';

interface IAdminPage {
  name: string;
  route: string;
}

interface IProps {
  user: string;
}

const emptyPages: IAdminPage[] = [];

const AdminUserPage = ({ user }: IProps) => {
  const [pages, setPages] = useState(emptyPages);

  useEffect(() => {
    axiosInstance.get(`/adminaccess/foruser/${user}`)
      .then(response => setPages(response.data))
      .catch(() => setPages(emptyPages));
  }, [user]);

  return (
    <div id="courses">
      <div id="title">
        <h1>Admin pour {user}</h1>
      </div>
      <div id="content">
        {pages.map((p) => (
          <Link key={p.route} className="button" to={p.route}>{p.name}</Link>
        ))}
      </div>
    </div>
  )
};

export default AdminUserPage;
